/**
 * @generated SignedSource<<4514b211f503ca84e084a4af33c6d9cb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectCategoryCell$data = {
  readonly category: {
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ProjectCategoryCell";
};
export type ProjectCategoryCell$key = {
  readonly " $data"?: ProjectCategoryCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectCategoryCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ProjectCategoryCell",
  "selections": [
    {
      "concreteType": "JiraProjectCategory",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "3e433ee157c53cef2d90d387f1dfe23b";

export default node;
